import { ui } from 'modules/common';
import { useCallback, useMemo } from 'react';

import { SelectDayProps } from './SelectDay.types';

export const useSelectDay = (
    options: ui.DayReference[],
    day: SelectDayProps['day'],
    onChange: SelectDayProps['onChange']
) => {
    const value = useMemo(() => {
        return day ? options.find((option) => Number(option.dayIndex) === Number(day))?.id : undefined;
    }, [day, options]);

    const handleChange = useCallback(
        (valueNext: number | string) => {
            onChange(Number(valueNext), options);
        },
        [onChange, options]
    );

    return {
        value,
        handleChange,
    };
};
